var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import axios from 'axios';
import Url from './Url';

var AjtAjaxAxios =
/** @class */
function () {
  // Constructor
  // urlBase,   opcional, part inical de la url que es cridarà amb els requests.
  // urlBD,     opcional, part de la url que correspon a la base de dades i que es cridarà amb els requests.
  // urlEntorn, opcional, part de la url que correspon a l'entorn (intranet/extranet) i que es cridarà amb els requests.
  // onLoadingChange,   funció que es cridarà amb true quan comença el request i amb false quan acaba el request.
  //                    La crida amb true només es farà si el request tarda més de isLoadingTimeOut milisegons a acbar (per defecte 1 segon)
  // onError,           funció que es cridarà si hi ha algun error al fer la crida
  function AjtAjaxAxios(parms) {
    if (parms === void 0) {
      parms = {};
    }

    this.cancelFunction = [];
    this.urlBase = parms.urlBase || '';
    this.urlBD = parms.urlBD || '';
    this.urlEntorn = parms.urlEntorn || '';
    this.isLoadingFunction = parms.onLoadingChange;
    this.errorFunction = parms.onError;
  }

  Object.defineProperty(AjtAjaxAxios.prototype, "isLoadingCallback", {
    // Assigna la funció que es cridarà (true) quan comença i acaba (false) a fer la càrrega
    set: function set(value) {
      this.isLoadingFunction = value;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(AjtAjaxAxios.prototype, "errorCallback", {
    // Assigna la funció que es cridarà si hi ha algun error al fer la crida
    set: function set(value) {
      this.errorFunction = value;
    },
    enumerable: true,
    configurable: true
  }); // Arregla i llança l'error

  AjtAjaxAxios.prototype.thowError = function (error) {
    if (this.errorFunction) {
      //Arregla
      if (error.response && error.response.data) {
        error.message = error.response.data.ExceptionMessage || error.response.data.Message || error.message;
        error.stackServer = error.response.data.StackTrace || error.stackServer;
      } //Llança


      this.errorFunction(error);
    } //La promesa també torna error


    throw new Error(error.message);
  }; // Cancel·la el request anterior
  // No fem una crida a isLoadingFunction(false) per que es suposa que immediatament farem una crida al getRequest


  AjtAjaxAxios.prototype.cancelRequest = function (miss) {
    while (this.cancelFunction.length) {
      var canceler = this.cancelFunction.pop();
      canceler && canceler(miss);
    }
  }; // Fa una crida tipus GET, cancel·lant si cal el request anterior que no hagués acabat


  AjtAjaxAxios.prototype.getSequentialRequest = function (url, params, headers, config) {
    if (params === void 0) {
      params = {};
    }

    this.cancelRequest();
    return this.getRequest(url, params, headers, config);
  }; // Fa un acrida tipus GET


  AjtAjaxAxios.prototype.getRequest = function (url, params, headers, config) {
    var _this = this;

    if (params === void 0) {
      params = {};
    }

    this.startIsLoading(); // console.log("url: " + url);
    // console.log("params: " + JSON.stringify(params));

    return axios.get(this.calculaUrl(url), __assign({
      params: params,
      headers: headers,
      cancelToken: new axios.CancelToken(function (cancel) {
        _this.cancelFunction.push(cancel);
      })
    }, config)).then(function (response) {
      _this.endIsLoading();

      return response.data;
    }).catch(function (error) {
      _this.endIsLoading();

      error.request = {
        method: 'GET',
        url: url,
        data: params
      };

      _this.thowError(error);
    });
  }; // Fa una crida tipus POST


  AjtAjaxAxios.prototype.postRequest = function (url, data, headers) {
    var _this = this;

    this.startIsLoading();
    return axios.post(this.calculaUrl(url), data, {
      headers: headers,
      cancelToken: new axios.CancelToken(function (cancel) {
        _this.cancelFunction.push(cancel);
      })
    }).then(function (response) {
      _this.endIsLoading();

      return response.data;
    }).catch(function (error) {
      _this.endIsLoading();

      error.request = {
        method: 'POST',
        url: url,
        data: data
      };

      _this.thowError(error);
    });
  }; // Fa una crida tipus POST


  AjtAjaxAxios.prototype.postRequestRaw = function (url, data, config) {
    var _this = this;

    this.startIsLoading();
    return axios.post(this.calculaUrl(url), data, config).then(function (response) {
      _this.endIsLoading();

      return response.data;
    }).catch(function (error) {
      _this.endIsLoading();

      error.request = {
        method: 'POST',
        url: url,
        data: data
      };

      _this.thowError(error);
    });
  }; // Fa una crida tipus PUT


  AjtAjaxAxios.prototype.putRequest = function (url, data, headers) {
    var _this = this;

    this.startIsLoading();
    return axios.put(this.calculaUrl(url), data, {
      headers: headers
    }).then(function (response) {
      _this.endIsLoading();

      return response.data;
    }).catch(function (error) {
      _this.endIsLoading();

      error.request = {
        method: 'PUT',
        url: url,
        data: data
      };

      _this.thowError(error);
    });
  }; // Fa una crida tipus PATCH


  AjtAjaxAxios.prototype.patchRequest = function (url, data, headers) {
    var _this = this;

    this.startIsLoading();
    return axios.patch(this.calculaUrl(url), data, {
      headers: headers
    }).then(function (response) {
      _this.endIsLoading();

      return response.data;
    }).catch(function (error) {
      _this.endIsLoading();

      error.request = {
        method: 'PATCH',
        url: url,
        data: data
      };

      _this.thowError(error);
    });
  }; // Fa una crida tipus DELETE


  AjtAjaxAxios.prototype.deleteRequest = function (url, headers) {
    var _this = this;

    this.startIsLoading();
    return axios.delete(this.calculaUrl(url), {
      headers: headers
    }).then(function (response) {
      _this.endIsLoading();

      return response.data;
    }).catch(function (error) {
      _this.endIsLoading();

      error.request = {
        method: 'DELETE',
        url: url
      };

      _this.thowError(error);
    });
  }; // Si cal, crida a lafunció IsLoadingCallback amb el paràmetre true


  AjtAjaxAxios.prototype.startIsLoading = function () {
    if (this.isLoadingFunction) {
      this.isLoadingFunction(true);
    }
  }; // Si cal, crida a lafunció IsLoadingCallback amb el paràmetre false


  AjtAjaxAxios.prototype.endIsLoading = function () {
    if (this.isLoadingFunction) {
      this.isLoadingFunction(false);
    }
  }; // Composa la url a partir de la urlBase + urlBD + urlEntorn + url


  AjtAjaxAxios.prototype.calculaUrl = function (url) {
    return Url.composa(this.urlBase, this.urlBD, this.urlEntorn, url);
  };

  return AjtAjaxAxios;
}();

export default AjtAjaxAxios;